import { Component } from '@angular/core';

@Component({
  selector: 'sf-default-field',
  template: `<p>Unknow type</p>`
})
export class DefaultWidget {}
